import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import DatePickers from './DatePicker'
import Phone from './Phone'
import Email from './Email'
import LongText from './LongText'

const SubstanceAbuseTreatmentIntakeForm = () => {
    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم پذیرش درمان سوء مصرف مواد'} subHeader={'لطفا اطلاعات زیر را ارائه دهید تا به ما در درک نیازهای شما و ارائه مراقبت‌های مناسب کمک کند.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <DatePickers header={'تاریخ تولد'}/>
                <Phone header={'شماره تلفن'} />
                <Email header={'آدرس ایمیل'} />
                <FullName header={'نام و نام خانوادگی مسئول اضطراری'} />
                <Phone header={'شماره تلفن تماس اضطراری'} />
                <LongText header={'داروهای فعلی'}/>
                <LongText header={'سابقه درمان سوء مصرف مواد (در صورت وجود)'}/>
                <LongText header={'دلیل مراجعه به پزشک'}/>
                <LongText header={'آیا آلرژی دارید؟'}/>
                <LongText header={'نکات یا نگرانی‌های اضافی'}/>
            </Grid>
        </Grid>
    )
}

export default SubstanceAbuseTreatmentIntakeForm
